
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lista",
      function () {
        return require("private-next-pages/lista.js");
      }
    ]);
  